"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Base_1 = __importDefault(require("./Base"));
const { merge } = require('lodash');
const defaults = {
    settings: {
        fields: [],
    },
    strings: {
        formPrompt: 'Prompt',
        formFooter: 'Footer',
    },
};
class CompanyEvent extends Base_1.default {
    constructor(data) {
        super({});
        this.metadata = {};
        this.selfMerge(defaults);
        this.selfMerge(data);
    }
    get settings() {
        return this.metadata.settings;
    }
    get strings() {
        return this.metadata.strings;
    }
}
exports.default = CompanyEvent;
